import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { requiredField } from '~/ui/constants/errorMessages';

const validationSchema = object().shape({
  userPrompt: string().required(requiredField).typeError(requiredField),
});

export default yupResolver(validationSchema);
